import { SubmissionError } from 'redux-form';
import strings from 'app/strings';
import * as client from 'app/api/contentful-client';
import * as commonActions from '../actions/common';
import common from '../reducers/common';

function validationErrors(err) {
  const { data } = err;
  const { errors } = data || {};
  if (!errors) {
    // no validation data, so log this error to understand why it failed
    console.error(err); // eslint-disable-line no-console
  }
  throw new SubmissionError(errors || { _error: strings.GENERIC_SUBMIT_ERROR });
}

export const fetchUser = () => ({
  promise: http => http.get('/user/v1/profile').catch(() => ({})),
  events: ['PROMISE_PENDING', commonActions.SET_USER, 'PROMISE_ERROR'],
});

export const fetchFeatures = ip => ({
  promise: http => http.get(`/storefront/api/features?ip=${ip}`).catch(() => ({})),
  events: ['PROMISE_PENDING', commonActions.SET_FEATURE_FLAGS, 'PROMISE_ERROR'],
});

export const fetchAddressStates = (id) => {
  let uri = '/storefront/api/states';
  uri += id ? `?country_id=${id}` : '';
  return ({
    promise: http => http.get(uri),
    events: ['PROMISE_PENDING', commonActions.SET_ADDRESS_STATES, 'PROMISE_ERROR'],
  });
};

export const fetchAddressCountries = () => ({
  promise: http => http.get('/api/countries/?per_page=500'),
  events: ['PROMISE_PENDING', commonActions.SET_ADDRESS_COUNTRIES, 'PROMISE_ERROR'],
});

export const updateUserProfile = values => ({
  promise: http => http.patch('/user/v1/profile', values).catch(validationErrors),
  events: ['PROMISE_PENDING', commonActions.UPDATE_PROFILE, commonActions.UPDATE_PROFILE_ERROR],
});

export const setUserShippingInfo = values => ({
  promise: http => http.put('/storefront/api/users/current', values),
  events: [
    'PROMISE_PENDING',
    commonActions.SET_SHIPPING_INFO_SUCCESS,
    commonActions.SET_SHIPPING_INFO_ERROR,
  ],
});

export const fetchMachinesForUser = () => ({
  promise: http => http.get('/gfcore/users/machines.json?include_users=true'),
  events: [commonActions.MACHINES_LOADING, commonActions.SET_MACHINES, 'PROMISE_ERROR'],
});

export const fetchNoGlowforgePage = () => ({
  promise: () => client.getPage('onboarding-no-glowforge'),
  events: ['PROMISE_PENDING', commonActions.SET_NO_GLOWFORGE_PAGE, 'PROMISE_ERROR'],
});

export const fetchGlobalFooter = () => ({
  promise: () => client.getGlobalFooter(),
  events: ['PROMISE_PENDING', commonActions.SET_GLOBAL_FOOTER, 'PROMISE_ERROR'],
});

export const fetchDefaultMetadata = () => ({
  promise: () => client.getDefaultMetadata(),
  events: ['PROMISE_PENDING', commonActions.SET_DEFAULT_METADATA, 'PROMISE_ERROR'],
});

export const fetchReferral = email => ({
  promise: http => http.get(`/base://storefront/api/referral?email=${email}`),
  events: ['PROMISE_PENDING', commonActions.SET_REFERRAL_INFO, 'PROMISE_ERROR'],
});




// WEBPACK FOOTER //
// ./app/common/api/common-api.js